'use client';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Box, Typography } from '@mui/material';
import React from 'react';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { MediaCard } from '@/components/Card/MediaCard';
import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import {
  ComponentBlocksImage,
  Enum_Componentshareddisplayoptions_Contentswidth,
  UploadFile,
} from '@/types';

export function ImageBlock({ block }: { block: ComponentBlocksImage }) {
  const mediaItems = (block.Images ?? []).filter((item): item is UploadFile => Boolean(item?.url));

  const caption = block?.ImageCaption;

  if (!mediaItems.length) return null;

  const isSingle = mediaItems.length === 1;

  return (
    <CustomBackground
      backgroundOptions={(block?.ImageBackground ?? undefined) as StrapiBackgroundOptions}
      displayOptions={
        (block?.ImageDisplayOptions ?? {
          ContentsWidth: Enum_Componentshareddisplayoptions_Contentswidth.Standard,
          PaddingTop: block.ImageDisplayOptions?.PaddingTop ?? 'md',
          PaddingBottom: block.ImageDisplayOptions?.PaddingBottom ?? 'md',
          PaddingInline: block.ImageDisplayOptions?.PaddingInline ?? 'sm',
        }) as StrapiDisplayOptions
      }
    >
      {isSingle ? (
        // Single image: natural aspect ratio, no crop
        <MediaCard
          media={mediaItems[0]}
          fit="contain"
          width={block.CustomWidth || 0}
          height={block.CustomHeight || 0}
        />
      ) : (
        // Multiple: carousel with consistent aspect ratio
        <Swiper
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true }}
          spaceBetween={16}
          slidesPerView={1}
          breakpoints={{
            600: { slidesPerView: 1.25 },
            900: { slidesPerView: 1.5 },
            1200: { slidesPerView: 2 },
          }}
        >
          {mediaItems.map((_media, idx) => (
            <SwiperSlide key={idx}>
              <Box sx={{ px: 1 }}>
                <MediaCard
                  media={mediaItems[0]}
                  fit="contain"
                  width={block.CustomWidth || 0}
                  height={block.CustomHeight || 0}
                />{' '}
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      {caption && (
        <Typography
          variant="caption"
          align="center"
          sx={{
            mt: 1.5,
            color: 'text.secondary',
            display: 'block',
            fontStyle: 'italic',
          }}
        >
          {caption}
        </Typography>
      )}
    </CustomBackground>
  );
}
